import { render, staticRenderFns } from "./Padder.vue?vue&type=template&id=d86aa216&"
import script from "./Padder.vue?vue&type=script&lang=js&"
export * from "./Padder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports